import { stringify } from 'query-string'

import { getOnce } from 'utils/helper'

export const getSuggestionBankRef = (params) => {
  const query = stringify(params)

  return getOnce(`/refBanks/suggestionPerPage?${query}`)
}
